<em-main>
  @if (pageObject$ | async; as pageObject) {
    <div class="flex flex-column gap-4">
      <div class="justify-content-between layout--row">
        <h2 i18n>Proposition du client</h2>
        <em-underwriting-info-card
          [readonly]="[status.APPROVED, status.REFUSED, status.CANCELED].includes(pageObject.status.value)"
          [props]="{
            policyNumber: pageObject.policyNumber,
            status: pageObject.status,
            underwriters: pageObject.underwriters,
            underwriterId: pageObject.underwriterId,
          }"
          (propsChange)="saveUnderwriter($event)" />
      </div>
      <div class="layout--row gap-4">
        <!-- does not display when printing screen -->
        @if (pageObject.notes) {
          <em-notes-section
            id="notes-side-section"
            [props]="pageObject.notes"
            (propsChange)="saveNote($event)" />
        }
        <div class="layout--full-width layout--column layout--gap-larger">
          @if (pageObject.profileInfo) {
            <em-profile-info [profileInfo]="pageObject.profileInfo" />
          }
          <em-client-info-section
            [props]="pageObject.clientInfo"
            [readonly]="true"
            (replacementNoticeDocumentRequested)="
              downloadDocument({documentName: DocumentName.REPLACEMENT_NOTICE, callback: $event})
            " />
          @if (pageObject.healthQuestionnaire) {
            <em-health-questionnaire-section
              [props]="{
                healthQuestionnaire: pageObject.healthQuestionnaire,
                healthAnswers: pageObject.healthAnswers,
              }"
              [readonly]="true" />
          }
          @if (pageObject.extraQuestionnaireInfo) {
            @if (isManuallyAddedToContractEnabled) {
              <em-extra-questionnaires-section
                [props]="pageObject.extraQuestionnaireInfo"
                (downloadDocument)="downloadDocument($event)"
                (updateIsIncludedInContract)="updateIsIncludedInContract($event)"
                [readonly]="
                  [status.APPROVED, status.REFUSED, status.CANCELED].includes(pageObject.status.value)
                " />
            } @else {
              <em-extra-questionnaires-section
                [props]="pageObject.extraQuestionnaireInfo"
                (downloadDocument)="downloadDocument($event)"
                (updateIsIncludedInContract)="updateIsIncludedInContract($event)"
                [readonly]="true" />
            }
          }
          @if (pageObject.proposalNote) {
            <em-proposal-note-section [props]="pageObject.proposalNote" [readonly]="true" />
          }
          @if (pageObject.requestableExtraQuestionnaires) {
            <em-requestable-extra-questionnaires-section
              [props]="pageObject.requestableExtraQuestionnaires"
              [readonly]="
                [status.APPROVED, status.REFUSED, status.CANCELED].includes(pageObject.status.value)
              "
              (propsChange)="createHealthAnswersRevision($event)" />
          }
          @if (pageObject.surchargeSummary) {
            <em-modification-section
              [props]="pageObject.surchargeSummary"
              [readonly]="
                [status.APPROVED, status.REFUSED, status.CANCELED].includes(pageObject.status.value)
              "
              (profileRefused)="onProfileRefused($event)"
              (profileApproved)="onProfileApproved($event)"
              (propsChange)="updateSurchargeRate($event.output)" />
          }
          <em-extra-requirements-section
            [props]="pageObject.extraRequirementsFile"
            [readonly]="[status.APPROVED, status.REFUSED, status.CANCELED].includes(pageObject.status.value)"
            (propsChange)="submitExtraRequirements($event)"
            (uploadDocuments)="uploadDocuments($event)"
            (downloadDocument)="downloadDocument({documentName: $event, type: 'extraRequirements'})"
            (deleteDocument)="removeDocument($event)" />
          <!-- only displays when printing screen -->
          @if (pageObject.notes) {
            <em-notes-section
              class="hidden"
              id="notes-bottom-section"
              [props]="pageObject.notes"
              (propsChange)="saveNote($event)" />
          }
        </div>
      </div>
      <p-button
        (onClick)="cancel()"
        [loading]="isCancelButtonLoading"
        [disabled]="[status.APPROVED, status.REFUSED, status.CANCELED].includes(pageObject.status.value)"
        icon="pi pi-times"
        class="emma-pro-grey-btn flex justify-content-end"
        i18n-label
        label="Sans suivi" />
    </div>
  } @else {
    <em-skeleton />
  }
</em-main>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
